// import { TanStackDevtools } from '@tanstack/react-devtools'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter as Router } from 'react-router-dom'
import { ScrollToTop } from 'uikit'
import { ChakraProvider } from 'uikit/Provider/Provider'
import { Toaster } from 'uikit/Toaster'
import App from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

root.render(
  // <StrictMode>
  <ChakraProvider>
    <Router>
      <QueryClientProvider client={queryClient}>
        <ScrollToTop />
        <App />
        <Toaster />
        {/* <TanStackDevtools
              eventBusConfig={{ debug: true }}
              plugins={[
                {
                  name: 'TanStack Query',
                  render: <ReactQueryDevtoolsPanel />,
                },
              ]}
            /> */}
      </QueryClientProvider>
    </Router>
  </ChakraProvider>
  // </StrictMode>
)
